/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SomniaAddressDetailInfo = {
    ADDR: string;
    ADDRT: SomniaAddressDetailInfo.ADDRT;
    NM: string;
    BL: string;
    BLVAL: string;
    BLP: string;
    TKNCNT: string;
    FTRXUT: number;
    LTRXUT: number;
    CCADDR: string;
    CTRXHA: string;
};

export namespace SomniaAddressDetailInfo {

    export enum ADDRT {
        EOA = 'EOA',
        CA = 'CA',
    }


}

